import { FormField, FormSelect, FormSectionTitle } from '@practium/ui';
import styles from './AnalysisForm.module.css';

interface LocationFormSectionProps {
	property: string;
	area: string;
	sector: string[];
	errors: { property?: string; area?: string; sector?: string };
	onPropertyChange: (v: string) => void;
	onAreaChange: (v: string) => void;
	onSectorChange: (v: string[]) => void;
	propertyOptions: { value: string; label: string }[];
	areaOptions: { value: string; label: string }[];
	sectorOptions: { value: string; label: string }[];
}

export const LocationFormSection = ({
	property,
	area,
	sector,
	errors,
	onPropertyChange,
	onAreaChange,
	onSectorChange,
	propertyOptions,
	areaOptions,
	sectorOptions,
}: LocationFormSectionProps) => (
	<>
		<FormSectionTitle>Setor referente a análise</FormSectionTitle>
		<div className={styles.row3}>
			<FormField label="Propriedade" required error={errors.property}>
				<FormSelect
					value={property}
					onChange={onPropertyChange}
					options={propertyOptions}
					placeholder="Selecione a propriedade"
					hasError={!!errors.property}
					searchable
				/>
			</FormField>
			<FormField label="Área" required error={errors.area}>
				<FormSelect
					value={area}
					onChange={onAreaChange}
					options={areaOptions}
					placeholder="Selecione a área"
					hasError={!!errors.area}
					searchable
					disabled={!property}
				/>
			</FormField>
			<FormField label="Setor" error={errors.sector}>
				<FormSelect
					clearable
					multiple
					value={sector}
					onChange={onSectorChange}
					options={sectorOptions}
					placeholder="Selecione os setores"
					hasError={!!errors.sector}
					searchable
					disabled={!area}
				/>
			</FormField>
		</div>
	</>
);
